import { render, staticRenderFns } from "./PhotoUpload.vue?vue&type=template&id=352c7c3a&scoped=true&"
import script from "./PhotoUpload.vue?vue&type=script&lang=ts&"
export * from "./PhotoUpload.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoUpload.vue?vue&type=style&index=0&id=352c7c3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c7c3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressLinear})
